import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { colors, getInitialsColor } from './constants';

const RecentDemandeursTable = ({ recentDemandeurs }) => {
  const navigate = useNavigate();

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
        <span className="w-1.5 h-5 bg-blue-500 rounded-sm mr-2"></span>
        Demandeurs récents
      </h2>
      <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
        <div className="h-2" style={{ background: colors.gradient.blue }}></div>
        <div className="overflow-x-auto w-full">
          <table className="w-full divide-y divide-gray-200">
            <thead>
              <tr className="bg-gray-50">
                <th scope="col" className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-2/5">
                  Demandeur
                </th>
                <th scope="col" className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/6">
                  Âge
                </th>
                <th scope="col" className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/5">
                  Résidence
                </th>
                <th scope="col" className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/5">
                  Contact
                </th>
                <th scope="col" className="px-5 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider w-1/6">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {recentDemandeurs?.map((demandeur) => {
                const initials = `${demandeur.first_name.charAt(0)}${demandeur.last_name.charAt(0)}`;
                const initialsColor = getInitialsColor(initials);
                const age = demandeur.profile?.date_naissance ? 
                    new Date().getFullYear() - new Date(demandeur.profile.date_naissance).getFullYear() 
                    : 'N/A';
                
                return (
                  <tr key={demandeur.id} className="hover:bg-gray-50">
                    <td className="px-5 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-10 w-10 rounded-full overflow-hidden">
                          {demandeur.photo_url ? (
                              <img 
                                src={demandeur.photo_url} 
                                alt="Profile" 
                                className="h-full w-full object-cover"
                              />
                          ) : (
                              <div 
                                className="h-full w-full flex items-center justify-center text-white" 
                                style={{ background: initialsColor }}
                              >
                                {initials}
                              </div>
                          )}
                        </div>
                        <div className="ml-3">
                          <div className="text-sm font-medium text-gray-800">
                            {demandeur.first_name} {demandeur.last_name}
                          </div>
                          <div className="text-xs text-gray-500">
                            {demandeur.profile?.genre || 'Non spécifié'}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-4 whitespace-nowrap text-sm text-gray-500">
                      {age} ans
                    </td>
                    <td className="px-5 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-800">
                        {demandeur.profile?.adresse || 'Non spécifié'}
                      </div>
                      <div className="text-xs text-gray-500">
                        {demandeur.profile?.nationalite || 'Non spécifié'}
                      </div>
                    </td>
                    <td className="px-5 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-600 flex items-center">
                        <Mail size={14} className="mr-1.5 text-orange-500" /> 
                        {demandeur.email}
                      </div>
                      <div className="text-sm text-gray-600 flex items-center">
                        <Phone size={14} className="mr-1.5 text-orange-500" /> 
                        {demandeur.telephone || 'Non spécifié'}
                      </div>
                    </td>
                    <td className="px-5 py-4 whitespace-nowrap text-sm text-center">
                      <button 
                        onClick={() => navigate(`/demandeur/${demandeur.id}`)}
                        className="px-3 py-1 rounded-md text-white text-sm font-medium" 
                        style={{ background: colors.gradient.orange }}
                      >
                        Détails
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecentDemandeursTable;
